/**
 * Realm-Eater rule overrides.
 *
 * Card text (verbatim from sorcery-cards.json):
 *   "Tap → Play, draw, or digest a site.
 *    Destroys sites it successfully attacks, then becomes immobile
 *    until it digests."
 *
 * "Destroys sites it successfully attacks" is a passive combat
 * trigger in the automation sidecar: on_damage_dealt gated by
 * watch_target_filter(type Site) → convert_watch_target_to_rubble +
 * apply_status_to_self(immobile). The CombatEngine fires the trigger
 * when a site attack lands its life loss.
 *
 *   - Digest a site (Tap): clears `immobile`, freeing the avatar to
 *     move again. Enabled only while the avatar is immobile.
 *
 * Gate logic lives in `_canActivateEntry`'s `realm_eater_digest`
 * branch; the resolution side lives in `_activateAbility`.
 */
export const REALM_EATER_RULES = {
  extraActivatedAbilities: [
    {
      id: '__builtin_realm_eater_digest',
      trigger: 'activated',
      cost: [{ type: 'tap' }],
      description: 'Digest a site',
      _builtin: 'realm_eater_digest',
    },
  ],
};
